import { IEnvironmentConfiguration } from '../app/shared/environment-manager.shared';
import { environment as envQA } from './environment.qa';


// Default ENV used = QA.
export const environment: IEnvironmentConfiguration = envQA;
